import React from 'react';
import { AritoFormV2, AritoIcon, BottomActionBarV2, DialogV2 } from '@/components/custom/erp';
import { initialValues, SearchFormValues, searchSchema } from '../../schemas';
import { DonViTinh, DonViTinhInput } from '@/types/schemas';
import { FormMode } from '@/types/form';
import UnitForm from './UnitForm';

interface UnitDialogProps {
  mode?: FormMode;
  formMode?: FormMode;
  open: boolean;
  onClose: () => void;
  onSubmit?: (data: DonViTinhInput) => void;
  onAddButtonClick?: () => void;
  onEditButtonClick?: () => void;
  onDeleteButtonClick?: () => void;
  onCopyButtonClick?: () => void;
  onWatchButtonClick?: () => void;
  initialData?: DonViTinh;
  zIndex?: number;
}

function UnitDialog({
  mode,
  formMode,
  open,
  onClose,
  onAddButtonClick,
  onCopyButtonClick,
  onDeleteButtonClick,
  onEditButtonClick,
  initialData,
  onSubmit,
  zIndex
}: UnitDialogProps) {
  const resolvedMode = mode || formMode || 'add';

  const handleSubmit = async (data: SearchFormValues) => {
    try {
      onSubmit?.(data);
    } catch (err: unknown) {
      console.error('Error submitting form:', err);
    }
  };

  const title = resolvedMode === 'add' ? 'Mới' : resolvedMode === 'edit' ? 'Sửa' : 'Xem chi tiết';

  return (
    <>
      <DialogV2
        open={open}
        onClose={onClose}
        title={title}
        maxWidth='lg'
        disableBackdropClose={false}
        disableEscapeKeyDown={false}
        titleIcon={<AritoIcon icon={12} />}
        zIndex={zIndex}
      >
        <AritoFormV2
          mode={resolvedMode}
          hasAritoActionBar={false}
          schema={searchSchema}
          onSubmit={handleSubmit}
          initialData={(initialData || initialValues) as SearchFormValues}
          className='w-full md:min-w-[500px] lg:min-w-[600px]'
          headerFields={<UnitForm formMode={resolvedMode} />}
          bottomBar={
            <BottomActionBarV2
              mode={resolvedMode}
              onAdd={onAddButtonClick}
              onEdit={onEditButtonClick}
              onDelete={onDeleteButtonClick}
              onCopy={onCopyButtonClick}
              onClose={onClose}
            />
          }
        />
      </DialogV2>
    </>
  );
}

export default UnitDialog;
